import { render, staticRenderFns } from "./EquityChangeHk.vue?vue&type=template&id=0cab0a2f&scoped=true"
import script from "./EquityChangeHk.vue?vue&type=script&lang=js"
export * from "./EquityChangeHk.vue?vue&type=script&lang=js"
import style0 from "./EquityChangeHk.vue?vue&type=style&index=0&id=0cab0a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab0a2f",
  null
  
)

export default component.exports